import SignUpCard from '../components/auth/SignUp'
import { Fragment } from 'react'
import Footer from '../components/Footer'

function Login() {
  return (
    <Fragment>
      <div className="page-content auth-page">
        <SignUpCard />
      </div>
      <Footer></Footer>
    </Fragment>
  )
}

export default Login
